import { Service, service } from './di'

@service('releaseService')
export class ReleaseService extends Service {
    shouldDeprecateBackflippFlyerDetails: boolean = true
    shouldDeprecateBackflippFlyerItemDetails: boolean = true
    shouldDeprecateBackflippLoyaltyPrograms: boolean = true
    shouldDeprecateBackflippFlyersInfo: boolean = true
    shouldDeprecateBackflippSearch: boolean = true
    shouldDeprecateBackflippLocationByPostalCode: boolean = true
    shouldDeprecateBackflippLocationByIp: boolean = true
    shouldDeprecateBackflippSearchTerms: boolean = true
    shouldDeprecateBackflippMerchants: boolean = true
    shouldDeprecateBackflippData: boolean = true
    shouldDeprecateBackflippCouponDetails: boolean = true
    shouldUseAdAdapted: boolean = true
    shouldUseBlackfridayDesign: boolean = false

    async init() {
        // dummy until backend endpoint is ready
    }
}
